import { render, staticRenderFns } from "./ActiveDeletedDropdown.vue?vue&type=template&id=0a4b4e06&"
import script from "./ActiveDeletedDropdown.vue?vue&type=script&lang=ts&"
export * from "./ActiveDeletedDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports